export default {
  dbi_download_page_title: 'Download',
  dbi_download_page_hour: 'hour',
  dbi_download_page_hours: 'hours',
  dbi_download_page_minute: 'minute',
  dbi_download_page_minutes: 'minutes',
  dbi_download_page_second: 'second',
  dbi_download_page_seconds: 'seconds',
  dbi_download_page_short_waitting_tips: 'Your download has started, please wait a second.',
  dbi_download_page_long_waitting_tips: 'The esimated download time for the file you selected is {time}.',
  dbi_download_page_failly_tips: 'Download Failed, please go back to download page and try again.',
  dbi_download_page_no_close_tips: 'Please do not close the tabs during the download process.',
  dbi_download_page_maximum_number_of_rows_tips:
    '• The current maximum number of rows is 100,000, the remaining data will not be downloaded to excel.',
  dbi_download_modal_chart: 'Chart',
  dbi_download_modal_linechart_type: 'Line Chart',
  dbi_download_modal_shadowchart_type: 'Shadow Chart',
  dbi_download_modal_chart_size: 'Size',
  dbi_download_modal_chart_title: 'Title',
  dbi_download_modal_chart_title_tips: 'Include Graph title (with icon of the data source) and rank',
  dbi_download_modal_chart_peak: 'Peak Value & Date',
  dbi_download_modal_chart_total: 'Total Value & Time Interval',
  dbi_download_modal_chart_peak_subtitle: 'Daily Peak',
  dbi_download_modal_chart_total_subtitle: 'Total',
  dbi_download_modal_chart_preview: 'Preview',
  dbi_download_modal_chart_preview_tips: 'Include the start date, end date, peak date and relative data',
  dbi_download_modal_chart_dark: 'Applied in Dark Background',
  dbi_download_modal_setting_title: 'Chart Download Settings',
  dbi_download_modal_download_the_charts: 'Download The Charts',
  dbi_download_modal_download_the_metrics_data: 'Download The Metrics Data',
  dbi_download_modal_loading_failed: 'Loading failed, please',
  dbi_download_modal_loading_failed_try_again: 'Try again',
  dbi_download_chart_modal_no_data: 'No data',
  dbi_download_common_error_tips: 'Download failed, please try again.',
};
